<template>
  <Modal id="newuser" data-bs-backdrop="static">
    <template #header>
      <h5 class="modal-title">{{ $t('key_button_add_user') }}</h5>
    </template>
    <template #body>
      <div class="row">
        <p>
          {{ $t('key_text_type_user_email') }}
        </p>
        <form ref="newUser" class="needs-validation" novalidate>
          <div class="row">
            <div class="col-sm-12">
              <label class="text-primary">{{ $t('key_user_email') }} <span style="color:red">*</span> </label> 
              <input
                id="emailuser"
                ref="inputEmail"
                v-model="usuario.user"
                class="form-control"
                :placeholder="$t('key_type_email')"
                aria-label="Email"
                name="emailuser"
                required
                @input="validateEmail($event)"
              >
              <div v-if="invalidEmail" class="email-invalid-feedback">
                {{ $t('key_type_valid_email') }}
              </div>
              <div v-if="invalidEmailResponse" class="email-invalid-feedback">
                {{ invalidEmailResponseMessage }}
              </div>
              <div class="invalid-feedback">
                {{ $t('key_required_email') }}
              </div>
            </div>
            <div class="col-sm-12">
              <label class="text-primary">{{ $t('key_user_role') }} <span style="color:red">*</span> </label> 
              <hk-select id="userroles" ref="inputRole" v-model="usuario.role" class="form-control" name="userroles" :options="rolesOptions" :placeholder="$t('key_select_option')" required></hk-select>          
            </div>
          </div>
        </form>
      </div>
    </template>
    <template #footer>
      <button ref="closeButton" type="button" class="btn btn-outline-primary" data-bs-dismiss="modal" @click="resetUser">
        {{ $t('key_close') }}
      </button>
      <button type="button" class="btn bg-gradient-primary" :disabled="btnSendInvitation" @click="sendInvitation()">
        {{ $t('key_send_request') }}
      </button>
    </template>
  </Modal>
</template>
  
<script>
import Modal from "@/components/ModalHotakauth.vue";
import HkSelect from "@/hotaka/components/HkSelect.vue";
export default {
  components: {
    Modal,
    HkSelect
  },
  props: {},
  emits: ['hide', 'guardado'],
  data() {
    return {
      usuario: {
        user: "",
        role: ""
      },
      rolesOptions:[
        {
          value: 'USER',
          label: this.$t('key_user_role_user'),
        },
        {
          value: 'ADMIN',
          label: this.$t('key_user_role_admin'),
        }
      ],
      invalidEmail: false,
      invalidEmailResponseMessage: "",
      invalidEmailResponse: false,
      emailRegex: /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/
    };
  },
  computed: {
    newUsuario() {
      return this.$store.state.user.newUser.status;
    },
    btnSendInvitation(){
      return this.usuario.user == null || this.usuario.user =='' || 
      this.usuario.role == null || this.usuario.role =='';
    }
  },
  watch: {
    newUsuario(val) {
      if (val.created) {
        if (this.$store.state.user.newUser.data) {
          this.hideModal()
        } else if (val.error) {
          this.displayErrorResponse(true, val.error.error)
        }
      } else {
        this.displayErrorResponse(true, val.error.error)
      }
    },
  },
  created() {
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.hideModal();
      }
    });
  },
  methods: {
    displayErrorResponse(show, message = "") {
      let form = this.$refs.newUser;
      let input = this.$refs.inputEmail;
      if (show) {
        this.invalidEmail = true
        this.invalidEmailResponse = true;
        this.invalidEmailResponseMessage = message
        
        //input.classList.remove("email-invalid-feedback")
        input.classList.add("email-invalid-feedback-input")
        form.classList.remove('was-validated')
        return
      }

      this.invalidEmail = false
      this.invalidEmailResponse = false;
      this.invalidEmailResponseMessage = ""

      //input.classList.remove("email-invalid-feedback")
      input.classList.remove("email-invalid-feedback-input")
      form.classList.add('was-validated')

    },
    validateEmail($event) {
      let value = $event.target.value
      let form = this.$refs.newUser;
      this.displayErrorResponse(false)
      if (!value.match(this.emailRegex)) {
        $event.target.classList.add("email-invalid-feedback-input")
        this.invalidEmail = true
        form.classList.remove('was-validated')
        return
      }
      $event.target.classList.remove("email-invalid-feedback-input")
      this.invalidEmail = false
      form.classList.add('was-validated')
    },
    hideModal() {
      let button = this.$refs.closeButton;
      if (button) button.click()
    },
    resetUser() {
      this.usuario = {
        user: "",
        role: ""
      }

      this.displayErrorResponse(false)
      let form = this.$refs.newUser;
      form.classList.remove('was-validated')
    },
    sendInvitation() {
      this.displayErrorResponse(false)
      if (this.invalidEmail) {
        return
      }

      let form = this.$refs.newUser;
      if (form.checkValidity()) {
        const userLogged = JSON.parse(localStorage.getItem("user"));
        this.$store.commit("user/newUser", {
          tipo: "customer",
          id: userLogged["extraData"]["customerId"],
          user: this.usuario,
        });
        return
      }
      form.classList.add('was-validated')
    },
  },
};
</script>
  
<style lang="scss" scoped>
.modal-usuarios .modal-container {
  width: 550px !important;
}

.email-invalid-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #fd5c70;
}

.email-invalid-feedback-input {
  border-color: #fd5c70 !important;
  padding-right: unset !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23fd5c70' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23fd5c70' stroke='none'/%3e%3c/svg%3e") !important;
  background-repeat: no-repeat !important;
  background-position: right 0.75rem center !important;
  background-size: 1rem 1rem !important;
}

</style>